import React, {useState, useEffect} from 'react';
import { Button, TextField } from '@material-ui/core';
import {Box, Snackbar} from "@material-ui/core";
import Grid from '@mui/material/Grid';
import axiosInstance from "../../api";
import {Alert} from "@material-ui/lab";
import {MUIInput} from "../../utils/formUtils";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import Tooltip, {tooltipClasses} from '@mui/material/Tooltip';
import * as yup from "yup";

const validationSchema = yup.object().shape({ 
});

export default function SystemConfig (props) {
    const [fmapConfigdata, setFmapConfigData] = useState([]);
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [openSnackBarError, setOpenSnackBarError] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState(null);
    const { control, trigger, formState: {errors}} = useForm({resolver: yupResolver(validationSchema)});

    const title = "FMAP System Configuration Parameters";
    const subTitle = "FMAP System Configurations";
    const questionnaireTitle = "You may change the following FMAP system wide parameters and hit Save button";
    let questions = [
        {index:1, question:"Alert/popup parameters used to advise consumer to change Need-by-date Number to allow for lead time or call FMAP directly?"},
        {index:2, question:"How Many days before consumer property request need by date to send consumer notification email?"},
        {index:3, question:"How many days after participant selected the consumer property request to send participant reminder email?"},
        {index:4, question:"How many days between sending particpant reminder email and participant suspension email?"},
        {index:5, question:"Show maximum agent record"}
    ]

    useEffect(() => {
        if(fmapConfigdata.length === 0){
            getSystemConfig();
        }
    }, [])

    const getSystemConfig = () => {
        axiosInstance.get(`admin/get-all-config`)
        .then(data => {
            let configurationData = []
            configurationData = data
            configurationData = configurationData.sort((a,b) =>{
                if(a.configId > b.configId) return 1
                else if(a.configId < b.configId) return -1
                else return 0
            })
            setFmapConfigData(configurationData);
        })
        .catch(err =>{
        })
    }

    const updateSystemConfig = () => {
        axiosInstance.post(`admin/update-configs`, fmapConfigdata)
        .then(data => {
             let configurationData = []
             configurationData = data
             configurationData.sort((a,b) =>{
                 if(a.configId > b.configId) return 1
                 else if(a.configId < b.configId) return -1
                 else return 0
             })
             setFmapConfigData(configurationData);
             setSnackBarMessage('System Configurations updated successfully!');
             setOpenSnackBar(true);
            //getSystemConfig();
        })
        .catch(err =>{
            setOpenSnackBarError(true);
        })
    }

    const handleChange = (index) => e => {
        let newConfigValues = [...fmapConfigdata];
        newConfigValues[index].numericValue = Number(e.target.value);
        setFmapConfigData(newConfigValues);
    }

    const handleSave = () => {
        updateSystemConfig();
    }

    const handleSnackBarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackBar(false);
        setOpenSnackBarError(false);
    };

    return (
        <>
            <Box sm={5} m={3} l={1} paddingTop="1rem">
            {/* <Grid container alignItems="flex-start" columns={20} m={0} style={{marginBottom:"1rem", background:"#DBEAF5"}}>
                {title}
            </Grid> */}
            <Snackbar open={openSnackBar} autoHideDuration={6000} onClose={handleSnackBarClose}>
                <Alert variant="filled" onClose={handleSnackBarClose} severity="success">{snackBarMessage}</Alert>
            </Snackbar>

            <Snackbar open={openSnackBarError} autoHideDuration={6000} onClose={handleSnackBarClose}>
                <Alert variant="filled" onClose={handleSnackBarClose} severity="error">{"Failed to update system configuations"}</Alert>
            </Snackbar>
            <Grid container alignItems="flex-start"  spacing={2} >
                                {questions.map((item, i) =>{
                            return (
                                <Grid item xs={12} sm={8} md={6}>
                                <MUIInput control={control} name={item.question} inputPrp={{maxLength: 20}}
                                          label={item.question}
                                          defaultValue={fmapConfigdata.length > 0 ? fmapConfigdata[i].numericValue : 0}
                                          value={fmapConfigdata.length > 0 ? fmapConfigdata[i].numericValue : 0}
                                          onInputChange={handleChange(i)} errors={errors}></MUIInput>
                            </Grid>
                            )
                        })}
                </Grid>
        </Box>
        <Box component="span" justifyContent="flex-start" alignItems="flex-start" display="flex" padding="0.5rem 1.5rem 1.5rem 1.5rem">
            <Button type="submit" variant="contained" color="primary" name="btnSubmit"  onClick={handleSave}>
                Save
            </Button>
        </Box>
    </>
    )

}
